// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1Gy8R","containerItemsCenter":"Skeleton_containerItemsCenter__26n9b"};